export const GET_PROFILE = "PROFILE@GET_PROFILE";
export const GET_PROFILE_INIT = "PROFILE@GET_PROFILE_INIT";
export const GET_PROFILE_SUCCESS = "PROFILE@GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "PROFILE@GET_PROFILE_FAILED";
export const UPDATE_INFO = "UPDATE_INFO";
export const UPDATE_INFO_INIT = "UPDATE_INFO_INIT";
export const UPDATE_INFO_SUCCESS = "UPDATE_INFO_SUCCESS";
export const UPDATE_INFO_FAILED = "UPDATE_INFO_FAILED";
export const GET_ALL_INVESTOR = 'GET_ALL_INVESTOR';
export const GET_ALL_INVESTOR_INIT = 'GET_ALL_INVESTOR_INIT';
export const GET_ALL_INVESTOR_SUCCESS = 'GET_ALL_INVESTOR_SUCCESS';
export const GET_ALL_INVESTOR_FAILED = 'GET_ALL_INVESTOR_FAILED';
export const GET_STRATEGY_INIT = "USER@GET_STRATEGY_INIT";
export const GET_STRATEGY = "USER@GET_STRATEGY";
export const GET_STRATEGY_SUCCESS = "USER@GET_STRATEGY_SUCCESS";
export const GET_STRATEGY_FAILED = "USER@GET_STRATEGY_FAILED";

export const UPDATE_COVER_IMAGE = 'UPDATE_COVER_IMAGE';
export const UPDATE_COVER_IMAGE_INIT = 'UPDATE_COVER_IMAGE_INIT';
export const UPDATE_COVER_IMAGE_SUCCESS = 'UPDATE_COVER_IMAGE_SUCCESS';
export const UPDATE_COVER_IMAGE_FAILED = 'UPDATE_COVER_IMAGE_FAILED';

export const UPDATE_COMPANY_LOGO = 'UPDATE_COMPANY_LOGO';
export const UPDATE_COMPANY_LOGO_INIT = 'UPDATE_COMPANY_LOGO_INIT';
export const UPDATE_COMPANY_LOGO_SUCCESS = 'UPDATE_COMPANY_LOGO_SUCCESS';
export const UPDATE_COMPANY_LOGO_FAILED = 'UPDATE_COMPANY_LOGO_FAILED';

export const SEARCH_PMRESULT = "FUND@SEARCH_PMRESULT";
export const SEARCH_PMRESULT_INIT = "FUND@SEARCH_PMRESULT_INIT";
export const SEARCH_PMRESULT_SUCCESS = "FUND@SEARCH_PMRESULT_SUCCESS";
export const SEARCH_PMRESULT_FAILED = "FUND@SEARCH_PMRESULT_FAILED";

export const SEARCH_REPORTRESULT = "FUND@SEARCH_REPORTRESULT";
export const SEARCH_REPORTRESULT_INIT = "FUND@SEARCH_REPORTRESULT_INIT";
export const SEARCH_REPORTRESULT_SUCCESS = "FUND@SEARCH_REPORTRESULT_SUCCESS";
export const SEARCH_REPORTRESULT_FAILED = "FUND@SEARCH_REPORTRESULT_FAILED";

export const SEARCH_RPRESULT = "FUND@SEARCH_RPRESULT";
export const SEARCH_RPRESULT_INIT = "FUND@SEARCH_RPRESULT_INIT";
export const SEARCH_RPRESULT_SUCCESS = "FUND@SEARCH_RPRESULT_SUCCESS";
export const SEARCH_RPRESULT_FAILED = "FUND@SEARCH_RPRESULT_FAILED";

export const GET_FUND_DETAIL = "FUND@GET_FUND_DETAIL";
export const GET_FUND_DETAIL_INIT = "FUND@GET_FUND_DETAIL_INIT";
export const GET_FUND_DETAIL_SUCCESS = "FUND@GET_FUND_DETAIL_SUCCESS";
export const GET_FUND_DETAIL_FAILED = "FUND@GET_FUND_DETAIL_FAILED";

export const UPLOAD_FILE_DECK = "FUND@UPLOAD_FILE_DECK";
export const UPLOAD_FILE_DECK_INIT = "FUND@UPLOAD_FILE_DECK_INIT";
export const UPLOAD_FILE_DECK_SUCCESS = "FUND@UPLOAD_FILE_DECK_SUCCESS";
export const UPLOAD_FILE_DECK_FAILED = "FUND@UPLOAD_FILE_DECK_FAILED";

export const UPLOAD_TEAR_SHEET = "FUND@UPLOAD_TEAR_SHEET";
export const UPLOAD_TEAR_SHEET_INIT = "FUND@UPLOAD_TEAR_SHEET_INIT";
export const UPLOAD_TEAR_SHEET_SUCCESS = "FUND@UPLOAD_TEAR_SHEET_SUCCESS";
export const UPLOAD_TEAR_SHEET_FAILED = "FUND@UPLOAD_TEAR_SHEET_FAILED";

export const GET_CLOUD_DECKS = "FUND@GET_CLOUD_DECKS";
export const GET_CLOUD_DECKS_INIT = "FUND@GET_CLOUD_DECKS_INIT";
export const GET_CLOUD_DECKS_SUCCESS = "FUND@GET_CLOUD_DECKS_SUCCESS";
export const GET_CLOUD_DECKS_FAILED = "FUND@GET_CLOUD_DECKS_FAILED";

export const GET_MEDIA = "FUND@GET_MEDIA";
export const GET_MEDIA_INIT = "FUND@GET_MEDIA_INIT";
export const GET_MEDIA_SUCCESS = "FUND@GET_MEDIA_SUCCESS";
export const GET_MEDIA_FAILED = "FUND@GET_MEDIA_FAILED";

export const GET_INVESTED_ALLOCATORS = "FUND@GET_INVESTED_ALLOCATORS";
export const GET_INVESTED_ALLOCATORS_INIT = "FUND@GET_INVESTED_ALLOCATORS_INIT";
export const GET_INVESTED_ALLOCATORS_SUCCESS = "FUND@GET_INVESTED_ALLOCATORS_SUCCESS";
export const GET_INVESTED_ALLOCATORS_FAILED = "FUND@GET_INVESTED_ALLOCATORS_FAILED";

export const GET_ALLOCATOR_USERS = "FUND@GET_ALLOCATOR_USERS";
export const GET_ALLOCATOR_USERS_INIT = "FUND@GET_ALLOCATOR_USERS_INIT";
export const GET_ALLOCATOR_USERS_SUCCESS = "FUND@GET_ALLOCATOR_USERS_SUCCESS";
export const GET_ALLOCATOR_USERS_FAILED = "FUND@GET_ALLOCATOR_USERS_FAILED";

export const CREATE_CHAT_ROOM = "FUND@CREATE_CHAT_ROOM";
export const CREATE_CHAT_ROOM_INIT = "FUND@CREATE_CHAT_ROOM_INIT";
export const CREATE_CHAT_ROOM_SUCCESS = "FUND@CREATE_CHAT_ROOM_SUCCESS";
export const CREATE_CHAT_ROOM_FAILED = "FUND@CREATE_CHAT_ROOM_FAILED";

